(() => {
  const source = document.getElementById('DisarGalleryTrialData');
  const dialog = document.getElementById('DisarGalleryTrial');
  if (!source || !dialog || typeof dialog.showModal !== 'function') return;
  const data = JSON.parse(source.textContent);
  data.images = data.media.filter(item => item.media_type === 'image').map(item => {
    const preview = item.preview_image || item;
    const alt = item.alt || data.title;
    const tag = alt.match(/\[color:([^\]]+)\]/);
    const url = new URL(preview.src || item.src,location.origin);
    const thumb = new URL(url);
    url.searchParams.set('width','2400');
    thumb.searchParams.set('width','120');
    return {id:item.id,color:tag?.[1]?.trim() || '',alt:alt.replace(/\[color:[^\]]+\]/g,'').trim(),url:url.href,thumb:thumb.href,width:preview.width,height:preview.height};
  });
  const root = document.getElementById(`product-${data.productId}`);
  if (!root || !data.images.length) return;
  const picture = dialog.querySelector('.dgt-picture');
  const image = dialog.querySelector('.dgt-image');
  const rail = dialog.querySelector('.dgt-thumbs');
  const counter = dialog.querySelector('.dgt-counter');
  const close = dialog.querySelector('.dgt-close');
  let items = [], index = 0, zoom = 1, opener = null, oldOverflow = '';
  let origin = {x:50,y:50}, down = null, moved = false, color = '';
  const clean = value => String(value || '').trim().toLowerCase();
  function currentColor() {
    const id = root.querySelector('select[name="id"],input[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || data.selectedVariant;
    const variant = data.variants.find(v => String(v.id) === String(id));
    const checked = root.querySelector(`.swatch[data-option-index="${data.colorIndex}"] input:checked`);
    return clean(checked?.value || variant?.color);
  }
  function resetZoom() {
    zoom = 1;
    origin = {x:50,y:50};
    picture.classList.remove('is-zoomed','is-dragging');
    picture.setAttribute('aria-pressed','false');
    picture.setAttribute('aria-label',data.labels.zoomIn);
    image.style.transform = 'scale(1)';
    image.style.transformOrigin = '50% 50%';
  }
  function show(next) {
    if (!items.length) return;
    index = (next + items.length) % items.length;
    resetZoom();
    const item = items[index];
    picture.classList.add('is-loading');
    image.onload = () => picture.classList.remove('is-loading');
    image.onerror = () => picture.classList.remove('is-loading');
    image.fetchPriority = 'high';
    image.src = item.url;
    if (image.complete && image.naturalWidth) picture.classList.remove('is-loading');
    image.alt = item.alt;
    image.width = item.width;
    image.height = item.height;
    counter.textContent = `${index + 1} / ${items.length}`;
    rail.querySelectorAll('button').forEach((button,i) => button.setAttribute('aria-current',String(i === index)));
    rail.children[index]?.scrollIntoView({block:'nearest',inline:'nearest'});
    for (const offset of [-1,1]) {
      const nextImage = new Image();
      nextImage.src = items[(index + offset + items.length) % items.length].url;
    }
  }
  function build() {
    color = currentColor();
    items = data.images.filter(item => !item.color || clean(item.color) === color);
    rail.replaceChildren();
    items.forEach((item,i) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'dgt-thumb';
      button.setAttribute('aria-label',`${data.labels.image} ${i + 1}`);
      const thumb = document.createElement('img');
      thumb.src = item.thumb;
      thumb.alt = '';
      thumb.width = 48;
      thumb.height = 48;
      thumb.loading = 'lazy';
      button.append(thumb);
      button.addEventListener('click',() => show(i));
      rail.append(button);
    });
    dialog.querySelectorAll('.dgt-arrow').forEach(button => button.hidden = items.length < 2);
  }
  function open(id,trigger) {
    build();
    if (!items.length) return;
    opener = trigger;
    oldOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    dialog.showModal();
    const selected = items.findIndex(item => String(item.id) === String(id));
    show(Math.max(0,selected));
    close.focus({preventScroll:true});
  }
  document.addEventListener('click',event => {
    const link = event.target.closest('.shopify-product-gallery__image a,.woodmart-show-product-gallery');
    if (!link || !root.contains(link)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const selected = link.querySelector('img[data-image-id]') || root.querySelector('.owl-item.active img[data-image-id]') || root.querySelector('img[data-image-id]');
    open(selected?.dataset.imageId,link);
  },true);
  close.addEventListener('click',() => dialog.close());
  dialog.querySelector('.dgt-prev').addEventListener('click',() => show(index - 1));
  dialog.querySelector('.dgt-next').addEventListener('click',() => show(index + 1));
  dialog.addEventListener('click',event => {
    if (event.target === dialog || event.target.classList.contains('dgt-stage')) dialog.close();
  });
  dialog.addEventListener('close',() => {
    document.documentElement.style.overflow = oldOverflow;
    resetZoom();
    opener?.focus({preventScroll:true});
  });
  dialog.addEventListener('keydown',event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(index + (event.key === 'ArrowRight' ? 1 : -1));
    }
    if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      show(event.key === 'Home' ? 0 : items.length - 1);
    }
  });
  picture.addEventListener('click',event => {
    if (moved) { moved = false; return; }
    if (zoom > 1) return resetZoom();
    const bounds = picture.getBoundingClientRect();
    const keyboard = event.detail === 0;
    origin = keyboard ? {x:50,y:50} : {x:100 * (event.clientX - bounds.left) / bounds.width,y:100 * (event.clientY - bounds.top) / bounds.height};
    zoom = 2.3;
    picture.classList.add('is-zoomed');
    picture.setAttribute('aria-pressed','true');
    picture.setAttribute('aria-label',data.labels.zoomOut);
    image.style.transformOrigin = `${origin.x}% ${origin.y}%`;
    image.style.transform = `scale(${zoom})`;
  });
  picture.addEventListener('pointerdown',event => {
    down = {x:event.clientX,y:event.clientY,ox:origin.x,oy:origin.y};
    moved = false;
    picture.setPointerCapture(event.pointerId);
  });
  picture.addEventListener('pointermove',event => {
    if (!down) return;
    const dx = event.clientX - down.x, dy = event.clientY - down.y;
    if (Math.abs(dx) + Math.abs(dy) > 8) moved = true;
    if (zoom <= 1) return;
    picture.classList.add('is-dragging');
    const bounds = picture.getBoundingClientRect();
    origin = {x:Math.max(0,Math.min(100,down.ox - dx / bounds.width * 100)),y:Math.max(0,Math.min(100,down.oy - dy / bounds.height * 100))};
    image.style.transformOrigin = `${origin.x}% ${origin.y}%`;
  });
  picture.addEventListener('pointerup',event => {
    if (!down) return;
    const dx = event.clientX - down.x, dy = event.clientY - down.y;
    if (zoom === 1 && Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(index + (dx < 0 ? 1 : -1));
    down = null;
    picture.classList.remove('is-dragging');
  });
  picture.addEventListener('pointercancel',() => { down = null; picture.classList.remove('is-dragging'); });
})();
